
const Switch = ({ isOn, handleToggle, id, additionalData }) => {
  const switchStyle = {
    marginTop: "6px",
    display: "inline-block",
    width: "60px",
    height: "34px",
    position: "relative",
  };

  const sliderStyle = {
    position: "absolute",
    cursor: "pointer",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: isOn ? "#4caf50" : "#ccc",
    transition: ".4s",
    borderRadius: "34px",
  };

  const sliderBeforeStyle = {
    position: "absolute",
    content: '""',
    height: "26px",
    width: "26px",
    left: isOn ? "26px" : "4px",
    bottom: "4px",
    backgroundColor: "white",
    transition: ".4s",
    borderRadius: "50%",
  };

  return (
    <label style={switchStyle}>
      <input
        type="checkbox"
        checked={isOn}
        onChange={(e) => {
          handleToggle(e, { id });
        }}
        style={{ display: "none" }}
      />
      <span style={sliderStyle}>
        <span style={sliderBeforeStyle}></span>
      </span>
    </label>
  );
};

export default Switch; // Correctly export the Switch component
